import * as ManageRecipeTypes from 'Pages/managerecipe/state/editrecipe/types';
import { RecipeFieldEnum as RecipeFields } from 'Common/FieldEnum';

import * as types from './types';
import { DEFAULT_PAGE_SIZE } from '../constants';

const INITIAL_STATE = {
  searchResults: [],
  hasNextPage: false,
  loadingRecipes: false,
  error: null,
  pageSize: DEFAULT_PAGE_SIZE,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ManageRecipeTypes.MANAGE_RECIPE_WRITE_INACTIVE_SUCCESS:
      return {
        ...state,
        searchResults: state.searchResults.map(sr =>
          sr[RecipeFields.Id] !== payload.recipeId
            ? sr
            : { ...sr, [RecipeFields.Inactive]: payload.inactive }
        ),
      };
    case ManageRecipeTypes.MANAGE_RECIPE_DELETE_RECIPE_SUCCESS:
      return {
        ...state,
        searchResults: state.searchResults.filter(
          sr => sr[RecipeFields.Id] !== payload
        ),
      };
    case types.SET_PAGE_SIZE:
      return { ...state, pageSize: payload };
    case types.GET_RECIPES:
      return { ...state, loadingRecipes: payload };

    case types.SET_RECIPES: {
      const hasNextPage = payload.length === state.pageSize;

      return { ...state, searchResults: payload, hasNextPage };
    }

    case types.APPEND_RECIPES: {
      const hasNextPage = payload.length === state.pageSize;

      return {
        ...state,
        searchResults: state.searchResults.concat(payload),
        hasNextPage,
      };
    }

    case types.GET_RECIPES_ERROR:
      return { ...state, error: payload };

    case types.CLEAR_RECIPES:
      return { ...state, searchResults: [] };

    case types.RESET_RECIPE_STATE: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/state/reducer.js